// Contract addresses for Arbitrum One (mainnet)
const CONTRACTS = {
  LotteryV3: '0x6Cd715a5c93C74B37E1E953dcd4f83Fa3dB74e15',
  LotteryCore: '0x47a23F6650029A777d6411a01D52d2C64220bC87',
  TicketManager: '0x16377Bf7f8D09245389989A450caf58b65d80C21',
  VRFManager: '0xBB0728f322ef9D51B55e9EFfeF299f9F455EA72C',
  PrizeManager: '0xF163B9A35C853b42e5FAe125571cCaAfAD3Ea388',
  WinningsManager: '0xbA0ebAE974394bED9B1DD6d212Ddf46f016768Ac'
} as const;
export default CONTRACTS;
